/** @jsx jsx */
import { h, FunctionalComponent } from 'preact'
import { jsx } from '@emotion/core'

import { getDefaultScoreStylesObj } from './score.styles'
import { TeamObject } from '../../types/props'
import { useSiteVars } from '../../themes/useSiteVars'

interface ScoreProps {
    homeTeam: TeamObject
    homeScore: string
    awayTeam: TeamObject
    awayScore: string
    scoreType: string
    preview?: boolean
}

const Score: FunctionalComponent<ScoreProps> = ({
    homeTeam: homeTeamRaw,
    awayTeam: awayTeamRaw,
    homeScore,
    awayScore,
    scoreType,
    preview,
}) => {
    const siteVars = useSiteVars()

    const scoreStyles = getDefaultScoreStylesObj(siteVars, preview)

    let homeTeam = homeTeamRaw
    if (typeof homeTeamRaw === 'string') {
        homeTeam = JSON.parse(homeTeamRaw)
    }

    let awayTeam = awayTeamRaw
    if (typeof awayTeamRaw === 'string') {
        awayTeam = JSON.parse(awayTeamRaw)
    }

    return (
        <div css={scoreStyles.root}>
            <div css={scoreStyles.contentWrap}>
                <div css={scoreStyles.team}>
                    <img css={scoreStyles.logo} src={homeTeam.logoUrl} alt={`${homeTeam.name} logo`} />
                    {homeTeam.name}
                </div>
                <div css={scoreStyles.teamScore}>{homeScore}</div>
            </div>
            <div css={scoreStyles.scoreType}>{scoreType}</div>
            <div css={scoreStyles.contentWrap}>
                <div css={scoreStyles.team}>
                    <img css={scoreStyles.logo} src={awayTeam.logoUrl} alt={`${awayTeam.name} logo`} />
                    {awayTeam.name}
                </div>
                <div css={scoreStyles.teamScore}>{awayScore}</div>
            </div>
        </div>
    )
}

export default Score
